require('es6-shim');
require('es7-shim');
require('promise.prototype.finally').shim();

import Vue from './intermediario';

document.addEventListener('deviceready', function(){

    window.universalLinks.subscribe('abrirApp', function(datos){
        Vue.$router.push(datos.hash);
    });

}, false);

export default Vue;
